export const removeItemByIndex = <T>(items: T[], index: number): T[] =>
  items.filter((_, i) => i !== index)
